import { CssBaseline } from "@mui/material";
import { Banner } from "../../components";
import { Content } from "./resourceElements";
import { useDispatch } from "react-redux";
import React, { useEffect } from "react";
import { updateResources } from "../../data";

const Resources = () => {
  const dispatch = useDispatch();
  const bannerProps = {
    title: "Resources",
    subTitle:
      "GAMLS is advancing the next generation of medical laboratory delivery through policies that expand access to lifesaving testing services.",
  };

  useEffect(() => {
    const getData = setTimeout(() => {
      dispatch(updateResources());
    }, 2000);

    return () => clearTimeout(getData);
  }, [dispatch]);
  return (
    <>
      <CssBaseline />
      <Banner {...bannerProps} />
      <Content />
    </>
  );
};
export default Resources;
